import React, {Component} from 'react';
import {connect} from 'react-redux';
import {GuidesReducer} from "../../reducers/guides.reducer";
import GuidesActions from "../../actions/guides.action";
import {
    Button, Card, CardContent, CardActions, Dialog, DialogActions, DialogContent, DialogTitle, Slide,
    Typography, Icon
} from "material-ui";
import GuideForm from "./GuideForm";
import LoaderBtn from "../../shared/LoaderBtn/LoaderBtn";
import {submit} from 'redux-form';
import {withStyles} from 'material-ui/styles';
import moment from "moment";
import ReactMarkdown from 'react-markdown';
import Grid from 'material-ui/Grid';
import {SnackBarActions} from "../../actions/snackbar.actions";
import {Link} from "react-router-dom";
import BtnIcon from "../../shared/BtnIcon/BtnIcon";
import ReactGA from 'react-ga';

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

const styles = theme => ({

    card: {
        marginBottom: 16
    },
    subTitle: {
        marginBottom: 16,
        fontSize: 14,
        color: theme.palette.text.secondary,
    },

    guideContent: {
        height: 60
    }
});

class Guides extends Component {

    state = {
        fetchGuides: true,
        displayDialog: false,
        dialogEntity: undefined,
        dialogAction: undefined,
        isPerformingDialogAction: false
    };

    componentDidMount() {
        ReactGA.pageview(window.location.pathname + window.location.search);
        GuidesActions.fetchGuides().on('value', data => {
            let dataObj = data.val();
            let finalArr = [];
            if (data.val()) {
                Object.keys(data.val()).map(o => {
                    let object = dataObj[o];
                    object['id'] = o;
                    finalArr.push(object);
                });
            }
            finalArr.reverse();
            this.props.dispatch(GuidesReducer.set(finalArr));
            this.setState({fetchGuides: false});
        }, err => {
            this.setState({fetchGuides: false});
        })
    }

    render() {
        const {user} = this.props;
        return (
            <div>
                {(user && user.isAdmin) &&
                <Button
                    variant="raised"
                    color="primary"
                    onClick={() => this.handleActions(undefined, 'CREATE')}
                >
                    Guides du jeu
                </Button>
                }
                <h1>Liste des guides</h1>
                <Grid container>
                    {this.renderGuides()}
                </Grid>

                <Dialog
                    open={this.state.dialogAction !== undefined}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                    transition={Transition}
                    keepMounted
                    onClose={this.handleClose}
                >
                    <DialogTitle>
                        {this.renderActionTitle()}
                    </DialogTitle>
                    <DialogContent>
                        {this.renderActionContent()}
                    </DialogContent>
                    <DialogActions>
                        {this.renderActions()}
                    </DialogActions>
                </Dialog>
            </div>
        )
    }

    renderGuides = () => {
        const {guides, classes} = this.props;
        return guides.map((g, i) => {
            return (
                <Grid item md={4} xs={12} key={i}>
                    <Card className={classes.card}>
                        <CardContent>
                            <Typography variant="headline" component="h2">
                                {g.title}
                            </Typography>
                            <Typography className={classes.subTitle}>
                                {moment(g.created_at).format('dddd DD MMMM YYYY, h:mm')}
                            </Typography>
                            <Typography className={classes.guideContent}>
                                {g.resume}
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Link to={`guide/${g.id}`}>
                                <BtnIcon icon="remove_red_eye">Consulter</BtnIcon>
                            </Link>
                            <Button
                                variant="raised"
                                color="primary"
                                onClick={() => this.handleActions(g, 'EDIT')}>
                                Modifier
                            </Button>
                            <Button variant="raised" color="primary" onClick={() => this.handleActions(g, 'DELETE')}>
                                Supprimer
                            </Button>
                        </CardActions>
                    </Card>
                </Grid>
            )
        })
    };

    renderActionTitle = () => {
        switch (this.state.dialogAction) {
            case 'CREATE':
                return 'Créer un nouveau guide';
            case 'EDIT':
                return 'Editer le guide';
            case 'DELETE':
                return 'Supprimer ce guide';
            default:
                return '';
        }
    };

    renderActionContent = () => {
        switch (this.state.dialogAction) {
            case 'CREATE':
                return (
                    <GuideForm
                        onSubmit={this.handleCreate}
                    />
                );
            case 'EDIT':
                return (
                    <GuideForm
                        onSubmit={this.handleEdit}
                        initialValues={this.state.dialogEntity}
                    />
                );
            case 'DELETE':
                return (
                    <p>Confirmer la suppression du guide</p>
                );
            default:
                return '';
        }
    };

    renderActions = () => {
        switch (this.state.dialogAction) {
            case 'CREATE':
                return (
                    <div className="Dialog_actions_with_loader">
                        <Button color="primary" onClick={this.handleClose}>Annuler</Button>
                        <LoaderBtn
                            loading={this.state.isPerformingDialogAction}
                            onClick={this.submitRemotely}
                        >Créer</LoaderBtn>
                    </div>
                );
            case 'EDIT':
                return (
                    <div className="Dialog_actions_with_loader">
                        <Button color="primary" onClick={this.handleClose}>
                            Annuler
                        </Button>
                        <LoaderBtn loading={this.state.isPerformingDialogAction} onClick={this.submitRemotely}>
                            Sauvegarder
                        </LoaderBtn>
                    </div>
                );
            case 'DELETE':
                return (
                    <div className="Dialog_actions_with_loader">
                        <Button color="primary" onClick={this.handleClose}>
                            Annuler
                        </Button>
                        <LoaderBtn
                            loading={this.state.isPerformingDialogAction}
                            onClick={this.deleteGuide}
                        >
                            Confirmer
                        </LoaderBtn>
                    </div>
                );
            default:
                return '';
        }
    };

    deleteGuide = () => {
        this.setState({isPerformingDialogAction: true});
        setTimeout(() => {
            GuidesActions.delete(this.state.dialogEntity.id).then(data => {
                this.setState({
                    isPerformingDialogAction: false,
                    dialogEntity: undefined,
                    dialogAction: undefined
                });
                this.props.dispatch(SnackBarActions.displayMessage('Suppression effectuée avec succès'))
            })
        }, 2000)
    };

    submitRemotely = () => {
        this.props.dispatch(submit('guideForm'))
    };

    handleCreate = values => {
        this.setState({isPerformingDialogAction: true});
        setTimeout(() => {
            values['created_at'] = moment().format();
            GuidesActions.create(values).then(data => {
                this.setState({
                    isPerformingDialogAction: false,
                    dialogEntity: undefined,
                    dialogAction: undefined
                });
            }, err => {
                console.log(err)
            });

        }, 2000);
    };

    handleEdit = (values) => {
        this.setState({isPerformingDialogAction: true});
        setTimeout(() => {
            GuidesActions.edit(values).then(data => {
                this.setState({
                    isPerformingDialogAction: false,
                    dialogEntity: undefined,
                    dialogAction: undefined
                });
            });
        }, 2000)
    };

    handleActions = (guideToEdit, action) => {
        this.setState({
            dialogEntity: guideToEdit,
            dialogAction: action
        });
    };

    handleClose = () => {
        this.setState({
            dialogEntity: undefined,
            dialogAction: undefined
        });
    };
}

const state2props = state => ({
    user: state.User.user,
    guides: state.Guides.guides
});

export default connect(state2props)(withStyles(styles)(Guides));


// WEBPACK FOOTER //
// ./src/pages/guides/Guides.js